import React from 'react';
import Checkbox from 'Components/Checkbox';

export default ({dualSteering, currentSystem, handleDualSteeringCheck}) => {
  if (currentSystem && currentSystem.id === 5) {
    return (
      <section className='scene_section  dual-steering-section'>
        <header>Steering system</header>
        <div className='__main-alert-label'>
          Steering System consists of Steering Wheel and Electrical Steering Helm or Hydraulic Steering Helm or
          Mechanical Helm
        </div>
        <Checkbox value={dualSteering} onChange={handleDualSteeringCheck} label='Dual-Steering' labelType='_margin_left_10' />
      </section>
    );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/AddComponents/SteeringSystemSection.jsx